// PDF de la Orden de Compra (el mismo que se ve en ListadoOrdenesCompra)
// y envio automatico de ese PDF al correo del proveedor.
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import axios from "axios";

const fmt = (n) => new Intl.NumberFormat("en-US").format(n);
const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });

// Renglones de la OC (telasOC) -> filas del PDF
export function armarRenglonesOC(allTelasOrden, tipo) {
  return allTelasOrden
    .map((a) => {
      if (!(a.cantidad > 0)) return null;
      if (tipo == "Tela") {
        return {
          id: a._id,
          articulo: a.telas[0].codigo + " " + a.telas[0].nombre,
          descripcion: a.telas[0].tiposTelas[0].name,
          unidad: a.telas[0].unidad,
          colores: a.colores[0].name,
          cantidad: a.cantidad,
          precio: a.precio,
          descuento: a.descuento,
          total: a.total,
          pendiente_recibir: a.pendiente_recibir,
          observaciones: a.observaciones,
        };
      }
      return {
        id: a._id,
        articulo: a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
        descripcion: a.habilitacion[0].descripcion,
        unidad: a.habilitacion[0].unidad,
        colores: "NA",
        cantidad: a.cantidad,
        precio: a.precio,
        descuento: a.descuento,
        total: a.total,
        pendiente_recibir: a.pendiente_recibir,
        observaciones: a.observaciones,
      };
    })
    .filter((el) => el != null);
}

// oc: { fecha, plazo, fecha_compromiso, proveedores (nombre), total_kilos, total_metros,
//       total_piezas, total_general, observaciones, numero, tipo, impuestos, empresa }
export function construirPDFOC(oc, dataFinal) {
  const IVAPDF = oc.impuestos == "Si" ? oc.total_general * 0.16 : 0;
  const totalPDF = oc.impuestos == "Si" ? oc.total_general * 1.16 : oc.total_general;
  const doc = new jsPDF("landscape");
  var img = new Image();
  img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  doc.addImage(img, "png", 230, 30, 45, 15);

  if (oc.tipo == "Tela") {
    const dataPDFLimpia = dataFinal.map((a) => [
      a.articulo,
      a.descripcion,
      a.observaciones,
      a.unidad,
      a.colores,
      fmt(a.cantidad),
      "$" + fmt(a.precio),
      a.descuento + " %",
      "$" + fmt(a.total),
    ]);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Orden de Compra # ${oc.numero}`, 20, 20);
    doc.setFontSize(12);
    doc.text(`Fecha ${oc.fecha}`, 20, 25);
    doc.text(`Proveedor ${oc.proveedores}`, 20, 30);
    doc.text(`Plazo ${oc.plazo} días Compromiso ${oc.fecha_compromiso}`, 20, 35);
    doc.text(`Metros ${fmt(oc.total_metros)} / Kilos ${fmt(oc.total_kilos)} / Piezas ${fmt(oc.total_piezas)}`, 20, 40);
    doc.text(`Observaciones ${oc.observaciones}`, 20, 45);
    doc.autoTable({
      head: [["Articulo", "Descripcion", "Observaciones", "Unidad", "Color", "Cantidad", "Precio", "Descuento", "Total"]],
      body: dataPDFLimpia,
      startY: 50,
      foot: [["", "", "", "", "", "", "", "Total", "$" + fmt(oc.total_general)]],
      showFoot: "lastPage",
    });
    return doc;
  }

  const dataPDFLimpia = dataFinal.map((a) => [
    a.articulo,
    a.observaciones,
    a.unidad,
    fmt(a.cantidad),
    "$" + fmt(a.precio),
    a.descuento + " %",
    "$" + fmt(a.total),
  ]);
  doc.setFontSize(14);
  doc.text(`Empresa ${oc.empresa}`, 20, 15);
  doc.text(`Orden de Compra # ${oc.numero}`, 20, 20);
  doc.setFontSize(12);
  doc.text(`Fecha ${oc.fecha}`, 20, 25);
  doc.text(`Proveedor ${oc.proveedores}`, 20, 30);
  doc.text(`Plazo ${oc.plazo} días Compromiso ${oc.fecha_compromiso}`, 20, 35);
  doc.text(`Metros ${fmt(oc.total_metros)} / Kilos ${fmt(oc.total_kilos)} / Piezas ${fmt(oc.total_piezas)}`, 20, 40);
  doc.text(`Observaciones ${oc.observaciones}`, 20, 45);
  doc.autoTable({
    head: [["Articulo", "Color", "Unidad", "Cantidad", "Precio", "Descuento", "Total"]],
    body: dataPDFLimpia,
    startY: 50,
    foot: [
      ["", "", "", "", "", "SubTotal", "$" + fmt(oc.total_general)],
      ["", "", "", "", "", "IVA", "$" + fmt(IVAPDF)],
      ["", "", "", "", "", "Total", "$" + fmt(totalPDF)],
    ],
    showFoot: "lastPage",
  });
  doc.text(20, doc.autoTable.previous.finalY + 30, doc.splitTextToSize(`Nombre y Firma Proveedor`, 200));
  doc.text(23, doc.autoTable.previous.finalY + 23, doc.splitTextToSize(`___________________`, 200));
  doc.text(130, doc.autoTable.previous.finalY + 30, doc.splitTextToSize(`Firma de Comprador`, 200));
  doc.text(125, doc.autoTable.previous.finalY + 23, doc.splitTextToSize(`___________________`, 200));
  doc.text(230, doc.autoTable.previous.finalY + 30, doc.splitTextToSize(`Firma Recepción`, 200));
  doc.text(220, doc.autoTable.previous.finalY + 23, doc.splitTextToSize(`___________________`, 200));
  return doc;
}

// "a@a.a" es el relleno que se captura cuando no hay correo: no cuenta como correo
const correoValido = (e) => {
  const correo = String(e || "").trim().toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/.test(correo) && correo !== "a@a.a";
};

// Envia el PDF de la OC al correo registrado del proveedor.
// Devuelve { ok, email, error } (no lanza excepciones).
export async function enviarOCProveedor(idOC, userId) {
  try {
    const [{ data: ocDB }, { data: renglones }] = await Promise.all([
      axios.get(`${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idOC}`, { headers: headers() }),
      axios.get(`${process.env.REACT_APP_URL_TELAS_OC}/ordenesCompra/${idOC}`, { headers: headers() }),
    ]);
    if (!ocDB) return { ok: false, error: "No se encontro la orden de compra" };
    const proveedor = (ocDB.proveedores && ocDB.proveedores[0]) || {};
    const email = String(proveedor.email || "").trim();
    if (!correoValido(email)) {
      return { ok: false, error: `El proveedor ${proveedor.nombre_comercial || ""} no tiene correo registrado (tiene "${email}"); capturalo en el catalogo de Proveedores` };
    }
    const oc = {
      fecha: ocDB.fecha,
      plazo: ocDB.plazo,
      fecha_compromiso: ocDB.fecha_compromiso,
      proveedores: proveedor.nombre_comercial,
      total_kilos: ocDB.total_kilos,
      total_metros: ocDB.total_metros,
      total_piezas: ocDB.total_piezas,
      total_general: ocDB.total_general,
      observaciones: ocDB.observaciones,
      numero: ocDB.idOrdenCompra,
      tipo: ocDB.tipo,
      impuestos: ocDB.impuestos,
      empresa: ocDB.empresa,
    };
    const doc = construirPDFOC(oc, armarRenglonesOC(renglones, oc.tipo));
    const att = doc.output("datauristring").split(",")[1];
    const institucion = process.env.REACT_APP_NOMBRE_INSTITUCION || "";

    await axios.post(
      process.env.REACT_APP_URL_SEND_MAIL_ATT,
      {
        subject: `Orden de Compra #${oc.numero} ${institucion}`,
        email,
        fileName: `OC-${oc.numero}.pdf`,
        att,
        text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${institucion}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola ${proveedor.nombre_comercial || ""},</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras nuestra Orden de Compra #${oc.numero} con fecha ${oc.fecha} y compromiso de entrega ${oc.fecha_compromiso}.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
      },
      { headers: headers() }
    );

    axios
      .post(
        process.env.REACT_APP_URL_LOGS,
        { tipo: "Envio OC a Proveedor", detalle: `OC ${oc.numero} a ${email}`, user: userId },
        { headers: headers() }
      )
      .catch(() => {});
    return { ok: true, email };
  } catch (error) {
    const msg = (error.response && error.response.data && (error.response.data.message || error.response.data)) || error.message;
    return { ok: false, error: typeof msg === "string" ? msg : JSON.stringify(msg) };
  }
}
